/**
 * API клієнт для doc.customer_card_issue (Порція Роздріб.2/5a).
 * Backend: /api/v1/retail/customer-card-issue. Permissions: retail.customer_card.manage.
 */
import { api } from './client';
import type { Page } from './catalogs';

export interface CustomerCardIssue {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  customer_card_id: string;
  issued_by_user_id: string;
  pos_workstation_id: string | null;
  posted: boolean;
  posted_at: string | null;
  deletion_mark: boolean;
  created_at: string;
  created_by: string | null;
  comment: string | null;
}

export interface CustomerCardIssueCreate {
  organization_id: string;
  document_number?: string | null;
  document_date?: string | null;
  customer_card_id: string;
  pos_workstation_id?: string | null;
  comment?: string | null;
}

export type CustomerCardIssueUpdate = Partial<Omit<CustomerCardIssueCreate, 'organization_id' | 'customer_card_id'>>;

export const retailCustomerCardIssues = {
  list: (params?: { organization_id?: string; posted?: boolean; limit?: number; offset?: number }) =>
    api.get<Page<CustomerCardIssue>>('/retail/customer-card-issue', { params }).then((r) => r.data),
  get: (id: string) => api.get<CustomerCardIssue>(`/retail/customer-card-issue/${id}`).then((r) => r.data),
  create: (payload: CustomerCardIssueCreate) =>
    api.post<CustomerCardIssue>('/retail/customer-card-issue', payload).then((r) => r.data),
  update: (id: string, payload: CustomerCardIssueUpdate) =>
    api.patch<CustomerCardIssue>(`/retail/customer-card-issue/${id}`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/retail/customer-card-issue/${id}`).then(() => undefined),
  post: (id: string) =>
    api.post<CustomerCardIssue>(`/retail/customer-card-issue/${id}/post`).then((r) => r.data),
  unpost: (id: string) =>
    api.post<CustomerCardIssue>(`/retail/customer-card-issue/${id}/unpost`).then((r) => r.data),
};
